import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beSendCheckoutReceiptEmail = actionEndpointBe('beSendCheckoutReceiptEmail', H.post, 'receipt/:salonId/send-email/:transactionId/', (options, { transactionId, clientEmail }) => ({
  ...options,
  base: CONF.transactionApiRoot,
  params: { transactionId },
  data: { to: clientEmail },
}));
